import React from 'react'

const InlineSpinner = () => {
   return (
      <span className="query-loading">
         <img
            src="/logo/png/t2e-symbol-light.png"
            className="light-logo w-[25px] animate-[spin_1.7s_linear_infinite]"
            alt="loading spinner"
         />
         <img
            src="/logo/png/t2e-symbol-dark.png"
            className="dark-logo w-[25px] animate-[spin_1.7s_linear_infinite]"
            alt="loading spinner"
         />
      </span>
   )
}

export default InlineSpinner
